/**
 * User API Module
 * Handles user alias and preference management
 */

import axiosClient, { getApiBaseUrl, isNoAuthMode } from './client';
import { UserAliasRequest, UserAliasResponse } from './types';
import { getAuthType } from '../security/authStorage';

// ============================================================================
// User Alias Management
// ============================================================================

/**
 * Create user alias
 */
export async function createUserAlias(
  request: UserAliasRequest
): Promise<UserAliasResponse | void> {
  // Skip in no-auth/local mode
  if (isNoAuthMode()) {
    return;
  }
  
  const url = getApiBaseUrl('user-alias-service') + '/create';
  
  const response = await axiosClient.post<UserAliasResponse>(url, request);
  return response.data;
}

// ============================================================================
// Screen Configuration
// ============================================================================

/**
 * Get screen configuration
 */
export async function getScreenConfig(screenId: string): Promise<any> {
  // Skip in no-auth/local mode
  if (isNoAuthMode()) {
    return null;
  }
  
  const url = getApiBaseUrl('screen-config-service') + '/getScreenConfig';
  
  const response = await axiosClient.get(url, {
    params: { screenId },
  });
  
  return response.data;
}

// ============================================================================
// User Preferences
// ============================================================================

/**
 * Get user preferences for a screen
 */
export async function getUserPreferences(
  screenId: string,
  userAliasName: string
): Promise<any> {
  // Skip in no-auth/local mode
  if (isNoAuthMode()) {
    return null;
  }
  
  const authType = getAuthType();
  const authTypeCd = authType === 'msid' ? 'M' : 'O';
  
  const url = getApiBaseUrl('user-preference-service') + '/getUserPreferences';
  
  const response = await axiosClient.get(url, {
    params: {
      screenId,
      authTypeCd,
      userAliasName,
    },
  });
  
  return response.data;
}
